<template>
 <!-- <div style="min-height:34px"> -->
    <div class="block  w-100"  style="margin-top: 18px;">
		<div  class="footer-bottom">
			<template v-if="isButton">
			<!-- <el-button  @click="editClick('添加')"  v-if="getButton.indexOf('添加')>-1"  >添加</el-button>
			<el-button  @click="editClick('编辑')"  v-if="getButton.indexOf('编辑')>-1" :disabled="$store.state.select.length!=1">编辑</el-button>
			<el-button  @click="editClick('详情')"  v-if="getButton.indexOf('详情')>-1" :disabled="$store.state.select.length!=1">详情</el-button>
			<el-button  @click="editClick('复制')"  v-if="getButton.indexOf('复制')>-1" :disabled="$store.state.select.length!=1">复制</el-button>
			<el-button  @click="deleteClick()"  v-if="getButton.indexOf('删除')>-1" :disabled="$store.state.select.length==0">删除</el-button>
			<el-button  @click="editClick('导入')" v-if="getButton.indexOf('导入')>-1">导入</el-button>
			<el-button  @click="editClick('导出')" v-if="getButton.indexOf('导出')>-1&&getPage.pageTotal>0">导出</el-button>
			<el-button  @click="editClick('配置列')"v-if="$store.state.menu.isColumns" >配置列</el-button>
			<el-button  @click="editClick('批量处理')" :disabled="$store.state.select.length==0" v-if="getButton.indexOf('批量处理')>-1">批量处理</el-button>
			<el-button  @click="editClick('一键处理')"v-if="getPage.pageTotal>0&&getButton.indexOf('一键处理')>-1">一键处理</el-button>
			<el-button  @click="editClick('打印')" v-if="getButton.indexOf('打印')>-1">打印</el-button> -->
				<!-- <el-button  @click="editClick('配置列')" >配置列</el-button> -->
			<el-button  size="mini" class="b-primary text-primary" v-if="getButton.indexOf('删除')!=-1" :disabled="$store.state.select.length==0" @click="deleteClick()" ><img width="16" height="16" src="../../assets/icon/删除/蓝色.png" style=" vertical-align: middle;
			margin-right: 5px;">删除</el-button>
			<el-button  size="mini" class="b-primary text-primary" v-if="getButton.indexOf('一键')!=-1"  @click="editClick('一键处理')" ><img width="16" height="16" src="../../assets/icon/一键处理/蓝色.png" style=" vertical-align: middle;
			margin-right: 5px;">一键处理</el-button>
			<el-button   size="mini" style="border: 1px solid #2f54eb!important;" v-if="getButton.indexOf('导出')!=-1" @click="editClick('导出')" type="primary"><img width="16" height="16" src="../../assets/fxias.png" style=" vertical-align: middle;
margin-right: 5px;">导出</el-button>
			</template>
		</div>
		
    <el-pagination v-if="isInfo" class=" p-0" 
      @current-change="currentChange"
      :current-page.sync="pageInfo.pageIndex+1"
      :page-size="pageInfo.pageSize"
	   @size-change="sizeChange"
      layout="total,prev, pager, next, jumper,sizes"
      background
	    :page-sizes="[10, 30, 50, 100]"
      :total="pageInfo.pageTotal">
    </el-pagination>
	<el-pagination v-else class=" p-0"
	  @current-change="currentChange"
	  :current-page.sync="getPage.pageIndex+1"
	  :page-size="getPage.pageSize"
	   @size-change="sizeChange"
	  layout="total,prev, pager, next, jumper,sizes"
	  background
	    :page-sizes="[10, 30, 50, 100]"
	  :total="getPage.pageTotal">
	</el-pagination>
  </div>
  <!-- </div> -->
</template>
<script>
    export default {
     props: {
		 isButton: {
		 	type: Boolean,
		 	default: true
		 },
		 isInfo: {
		 	type: Boolean,
		 	default: false
		 },
		 pageInfo: {
		 	type: Object,
		 	default:()=>{return {}}
		 },
     },
      data() {
        return {
			button:''
        }
      },  
      methods: {
		deleteClick(){
			this.$confirm("您确认要删除此记录吗", "操作提示", {
				type: 'warning'
			}).then(() => {
				this.editClick('删除')
			}).catch(() => {});
		},
		  editClick(e){
			 if(e=='编辑'||e=='详情'||e=='删除'||e=='复制'){
				 
				 this.$emit("callbackOperate",{operate:e,data:this.$store.state.select[0]}); 
			 }else{
				  this.$emit("callbackOperate",{operate:e,data:this.$store.state.select}); 
			 }
		     this.$store.commit("saveOperate", e);
		  },
   currentChange(index){
     this.$emit("callbackIndex", index); //将值传给父组件
   },
   sizeChange(e){
	  var list= this.$store.state.list;
	  if(e==list.pageSize){return}
	  list.pageSize=e;
	  localStorage.setItem('PAGESIZE',e)
	   this.$store.commit("saveList", list);
	      this.$emit("callbackIndex", 1); //将值传给父组件
   }
   
      },
	 
	 computed:{
	 	getButton(){
	 		return this.$store.state.menu.meta?(this.$store.state.menu.meta.button||''):this.$store.state.menu.button||""
	 	},
		getPage(){
			return this.$store.state.list;
		}
	 },
	 mounted() {
	 }
      }
      
  </script>
 <style >
	 .block{display: flex;align-items: center;justify-content: space-between;}
	 .footer-bottom{display: flex;align-items: center;justify-content: space-between;}
	 .el-pagination__sizes{
		 margin: 0px;
	 }
	.el-pagination .el-select .el-input{
		margin-right: 0px;
	}
	/*  .el-pagination__total,.el-pagination__jump {
	      color:#409EFF!important ;
	  }
	  .el-pagination.is-background .el-pager li {
	     color: #409EFF;
	         border-color: #c6e2ff;
	         background-color: #ecf5ff;
	  }
	  .el-pagination.is-background .btn-prev:disabled {
	 
	  } */
	
  </style> 